import type { BlockRecord } from './types';

export type PageDocument = {
  block: BlockRecord;
  contentBlocks: BlockRecord[];
};

const cache = new Map<string, PageDocument>();

export function getCachedPageDocument(pageId: string): PageDocument | null {
  return cache.get(pageId) ?? null;
}

export function setCachedPageDocument(pageId: string, document: PageDocument): void {
  cache.set(pageId, document);
}

export function invalidatePageDocument(pageId: string): void {
  cache.delete(pageId);
}

export function clearAllPageDocuments(): void {
  cache.clear();
}

/** Drop cached pages whose page id or content block ids include any of `blockIds`. */
export function invalidatePageDocumentsTouching(blockIds: ReadonlySet<string>): void {
  for (const [pageId, document] of cache) {
    if (blockIds.has(pageId) || document.contentBlocks.some((block) => blockIds.has(block.id))) {
      cache.delete(pageId);
    }
  }
}

export function updateCachedPageTitle(pageId: string, title: string): void {
  const entry = cache.get(pageId);
  if (!entry) {
    return;
  }
  cache.set(pageId, {
    ...entry,
    block: { ...entry.block, title },
  });
}
